import React from "react";
import { Radio, Input } from 'antd';

const { TextArea } = Input

const ConfirmPdf = (props) => {
  const { data, setCheckData } = props;
  return (
    <>
      <div className="modalTips">文书审核结果</div>
      <div style={{ paddingLeft: 20 }}>
        <div className="row" style={{ margin: "20px 0" }}>
          <Radio.Group
            value={data?.status}
            onChange={(e) => setCheckData({...data,status: e.target.value})}
          >
            <Radio value={1}>审核通过</Radio>
            <Radio value={2}>审核不通过</Radio>
          </Radio.Group>
        </div>
        <div className="row" style={{ margin: "0 0 20px 0" }}>
          <TextArea
            rows={4}
            placeholder="请输入"
            style={{ marginLeft: 10, resize: "none", width: 400 }}
            onChange={(e) => setCheckData({...data, reason: e.target.value})}
            value={data?.reason}
          />
        </div>
      </div>
    </>
  );
};

export default ConfirmPdf;
